var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlusGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28.0 28.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.7193846,0 28,6.28007692 28,14 C28,21.7199231 21.7193846,28 14,28 C6.28061538,28 0,21.7199231 0,14 C0,6.28007692 6.28061538,0 14,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.223961973,0.223994281 C0.522620664,-0.0746647604 1.0067981,-0.0746647604 1.30545679,0.223994281 L4.54998398,3.468568 L7.79451116,0.224037008 C8.09316985,-0.0746220338 8.57734729,-0.0746220338 8.87600598,0.224037008 C9.17466467,0.522653323 9.17466467,1.00687406 8.87600598,1.3055331 L5.63152152,4.55002136 L8.87600598,7.79450963 C9.17466467,8.09316867 9.17466467,8.57734668 8.87600598,8.87600572 C8.57734729,9.17466476 8.09312713,9.17466476 7.79451116,8.87600572 L4.54998398,5.63147473 L1.30545679,8.87600572 C1.0067981,9.17466476 0.522620664,9.17466476 0.223961973,8.87600572 C-0.0746539911,8.5773894 -0.0746539911,8.09316867 0.223961973,7.79450963 L3.46848916,4.54997864 L0.223961973,1.30549037 C-0.0746539911,1.00687406 -0.0746539911,0.522653323 0.223961973,0.223994281 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,0 L35.7,35.7 L0,35.7 L0,0 L35.7,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.0 -773.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.0 760.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.0 13.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 28,0 28,28 0,28 0,0",
    stroke: "none",
    fill: "#7BCB44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.91630832287774 7.916308322868645)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.3606893389805919e-12 6.321391171171599) rotate(-43.99999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-5.55111512e-17,1.81890614e-12 9.1,1.81890614e-12 9.1,9.1 -5.55111512e-17,9.1 -5.55111512e-17,1.81890614e-12",
    stroke: "none",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.391207290000934 -4.547228262932145) rotate(43.99999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.41630832287072 -11.41630832287071)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11.4163083,11.4163083 24.2836917,11.4163083 24.2836917,24.2836917 11.4163083,24.2836917 11.4163083,11.4163083",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusGreen);
export default __webpack_public_path__ + "static/media/icPlusGreen.a3ac7cb2f77202258462c9b3ad02f27f.svg";
export { ForwardRef as ReactComponent };